var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widgets-ui-kit"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"}),_c('div',{staticClass:"col-6"},[_c('h2',[_vm._v("Виджет избранных адресов")]),_c('app-favorite-address')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }